import LineClamp from '@components/UI/molecules/LineClamp/LineClamp';
export default LineClamp;
